module.exports = __webpack_public_path__ + "img/icon-home.07c85427.svg";